import CounterfeitReportDetail from "./counterfeit-report-detail.container";


export default CounterfeitReportDetail;
